import findIndex from 'lodash/findIndex';
import get from 'lodash/get';
import { parse } from 'url';
import camelCase from 'lodash/camelCase';
import { initialState, getResourceState, getList, getDetail } from './selectors';
import {
  RESOURCE_CREATE_SUCCESS,
  RESOURCE_LIST_READ_REQUEST,
  RESOURCE_LIST_READ_SUCCESS,
  RESOURCE_DETAIL_READ_REQUEST,
  RESOURCE_DETAIL_READ_SUCCESS,
  RESOURCE_UPDATE_SUCCESS,
  RESOURCE_DELETE_SUCCESS,
  RESOURCE_DETAIL_READ_FAILURE,
  RESOURCE_LIST_READ_FAILURE,
  RESOURCE_CREATE_FAILURE,
} from './actions';
import urlTransform from '../../services/ant-redux/urlTransform';

const updateOrDeleteReducer = (state, { type, payload, meta }) => {
  const url = urlTransform(get(meta, 'resource'));
  const resource = camelCase(parse(url).path);

  // The needle should have `id` in it if we want to update state
  const needle = get(meta, 'request.needle.id');
  const needleIsObject = typeof needle === 'object';
  const list = getList(state, resource);
  const index = needleIsObject ? findIndex(list, needle) : list.indexOf(needle);
  let doneList = [];

  if (needle && index < 0) {
    return state;
  }

  switch (type) {
    case RESOURCE_UPDATE_SUCCESS:
      doneList = needle
        ? [
            ...list.slice(0, index),
            needleIsObject ? { ...list[index], ...payload } : payload,
            ...list.slice(index + 1),
          ]
        : [];

      return {
        ...state,
        [resource]: {
          ...getResourceState(state, resource),
          list: doneList,
          count: parseInt(get(meta, 'count', '0'), 10),
        },
      };
    case RESOURCE_DELETE_SUCCESS:
      doneList = needle ? [...list.slice(0, index), ...list.slice(index + 1)] : [];
      return {
        ...state,
        [resource]: {
          ...getResourceState(state, resource),
          list: doneList,
          count: parseInt(get(meta, 'count', '0'), 10),
        },
      };
    // istanbul ignore next
    default:
      return state;
  }
};

export default (state = initialState, { type, payload, meta }) => {
  const url = urlTransform(get(meta, 'resource'));
  const resource = camelCase(parse(url).path);

  if (!resource) {
    return state;
  }

  let list = [];

  switch (type) {
    case RESOURCE_CREATE_SUCCESS:
      if (Array.isArray(payload)) {
        list = [...payload, ...getList(state, resource)];
      } else {
        list = [payload, ...getList(state, resource)];
      }

      return {
        ...state,
        [resource]: {
          ...getResourceState(state, resource),
          list,
          count: parseInt(get(meta, 'count', '0'), 10),
        },
      };
    case RESOURCE_CREATE_FAILURE:
      return {
        ...state,
        [resource]: {
          ...getResourceState(state, resource),
          error: payload,
        },
      };
    case RESOURCE_LIST_READ_REQUEST:
      return {
        ...state,
        [resource]: {
          ...getResourceState(state, resource),
          list: getList(initialState, resource),
        },
      };
    case RESOURCE_LIST_READ_SUCCESS:
      return {
        ...state,
        [resource]: {
          ...getResourceState(state, resource),
          list: payload || [],
          count: parseInt(get(meta, 'count', '0'), 10),
        },
      };
    case RESOURCE_LIST_READ_FAILURE:
      return {
        ...state,
        [resource]: {
          ...getResourceState(state, resource),
          error: payload,
        },
      };
    case RESOURCE_DETAIL_READ_REQUEST:
      return {
        ...state,
        [resource]: {
          ...getResourceState(state, resource),
          detail: getDetail(initialState, resource),
        },
      };
    case RESOURCE_DETAIL_READ_FAILURE:
      return {
        ...state,
        [resource]: {
          ...getResourceState(state, resource),
          error: payload,
        },
      };
    case RESOURCE_DETAIL_READ_SUCCESS:
      return {
        ...state,
        [resource]: {
          ...getResourceState(state, resource),
          detail: payload || {},
          count: parseInt(get(meta, 'count', '0'), 10),
        },
      };

    case RESOURCE_UPDATE_SUCCESS:
    case RESOURCE_DELETE_SUCCESS:
      return updateOrDeleteReducer(state, { type, payload, meta });

    default:
      return state;
  }
};
